// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"393":"d35193856891a8af04f2","610":"d49bdece1e2623db4be3"}[chunkId] + ".bundle.js";
};